import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {CompositeProductComponentSearchModel} from "../composite-product-component-search.model";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";
import {EditMode} from "../../../framework/entity/edit/edit-page/edit-mode";

@Component({
    selector: "wbo-composite-product-component-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(CompositeProductComponentSingleSelectEditControlComponent),
        provideSearchModel(CompositeProductComponentSearchModel)
    ]
})
export class CompositeProductComponentSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<CompositeProductComponentSearchModel> {
    EditMode = EditMode;

    constructor(model: CompositeProductComponentSearchModel, injector: Injector) {
        super(model, injector, "id", "descriptor");
        this.labelSearchField = "name";
    }
}
